import { useTranslation } from 'react-i18next';
import { Stack, Text } from '@mantine/core';
import { NavbarButton } from './NavbarButton';

export function SettingsNavbar() {
  const { t } = useTranslation();

  return (
    <Stack h="100%" gap="sm">
      <NavbarButton label={t('settings.back-to-app')} icon="chevronLeft" href="/home" h={44} />
      <Stack gap="4xs">
        <Text size="xs" px="sm" py="3xs" c="gray.6" fw={400}>
          {t('settings.account')}
        </Text>
        <NavbarButton label={t('settings.profile')} icon="user" href="/settings/user" />
        <NavbarButton label={t('settings.mcp')} icon="webhook" href="/settings/mcp" />
      </Stack>
      <Stack gap="4xs">
        <Text size="xs" px="sm" py="3xs" c="gray.6" fw={400}>
          {t('settings.administration')}
        </Text>
        <NavbarButton label={t('settings.agency')} icon="building" href="/settings/agency" />
        <NavbarButton label={t('settings.ai')} icon="sparkles" href="/settings/ai" />
        <NavbarButton label={t('settings.users')} icon="users" href="/settings/users" />
        <NavbarButton label={t('settings.clients')} icon="briefcase" href="/settings/clients" />
        <NavbarButton label={t('settings.templates')} icon="template" href="/settings/templates" />
        <NavbarButton
          label={t('settings.integrations')}
          icon="webhook"
          href="/settings/integrations"
        />
        <NavbarButton
          label={t('settings.slack-notifications')}
          icon="brandSlack"
          href="/settings/slack-notifications"
        />
        <NavbarButton label={t('settings.holidays')} icon="calendar" href="/settings/holidays" />
        <NavbarButton label={t('settings.trello')} icon="brandTrello" href="/admin/trello" />
      </Stack>
    </Stack>
  );
}
